import styled, { css } from 'styled-components';
import {createPortal} from 'react-dom';

const modalCss = css`
position: fixed;
top: 0;
left: 0;
width: 100vw;
height: 100vh;
background-color: rgba(150, 150, 150, 0.5);
display: none;
&.open {
  display: flex;
  align-items: center;
  justify-items: center;
  z-index: 100;
}
> .content {
  position: relative;
  background-color: white;
  margin: 0 auto;
  max-width: 600px;
  width: 80vw;
  border-radius: 5px;
  border: 1px solid gray;
  > title {
    display: flex;
    align-content:center;
    justify-content: center;
    text-align:center;
    border-bottom: 1px solid gray;
    padding: 10px;
    font-weight: bold;
    font-size: 1em;
  }
  > main {
    padding: 20px;
  }

  > footer {
    display: flex;
    flex-wrap: wrap;
    column-gap: 1em;
    justify-content: flex-end;
    padding: 10px;
    padding-bottom: 15px;
    font-size: 0.75em;
  }
}`;

const Modal = styled(({ className, isOpen = false, children }) => {
  return createPortal(
    <div className={`${className} ${isOpen ? 'open' : ''}`}>
      <div className = 'content'>
      {children}
      </div>
    </div>, document.getElementById('modal')
  )
})`${modalCss}`

export default Modal;